import { CreateSellersGroupForm } from "../../components/emp/CreateSellersGroupForm";
import { AuthHelper } from '../../utils/auth_helper';

import React from "react";
import Grid from '@mui/material/Grid';


function CreateSellersGroup() {

  return (
    <div>
      <AuthHelper/>
      <div className="tw-px-5 tw-ml-10 sm:tw-ml-20 tw-text-left">

          <Grid container direction="row" alignItems="center" justifyContent="" >

            <Grid container>
              <Grid item xs={12} sm={12}>
                <span className="tw-p-10 tw-text-3xl"><p>Create Sellers Group</p></span>
              </Grid>
            </Grid>

            <CreateSellersGroupForm />

          </Grid>
          
      </div>

    </div>
  );

}


export { CreateSellersGroup };
